<template>
	<div>
		<b-navbar class="navbar">
			<b-nav-item v-if="showBackBtn" class="d-block" @click="$router.go(-1)">
				<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg" svgClasses="rotate-180" width="20" height="20"/>
			</b-nav-item>
		</b-navbar>
        <div class="custom-container">
            <router-view></router-view>
        </div>
	</div>
</template>

<script>
import { BNavbar, BNavItem } from 'bootstrap-vue'

export default {
	components: {
		BNavbar,
        BNavItem
	},
    computed: {
        showBackBtn () {
            return window.history.length > 1
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/.navbar {
    @include container-padding-private;

    @include mobile {
        padding: {
            top: 0;
            bottom: 0;
        }
    }
}
/deep/ .nav-item {
  margin-right: 0rem;
	font-weight: 600;

  @include media(mobile, tablets) {
    padding-right: 0;
    border: 0px !important;
  }
}

@include desktop {
	/deep/ .navbar-nav{
		margin-left: auto !important;
	}
}


/deep/ .navbar-brand {
  margin-right: 0;
}

.navbar {
	z-index: 1;
}

@include media(tablets, mobile) {
  /deep/ .navbar-nav{
    box-shadow: none !important;
    background-color: transparent !important;
    display: table;
  }
  .navbar {
    @include container-padding;
		@include tablets {
			padding: {
				top: 2rem;
				bottom: 2rem;
			}
		}
    .btn-dropdown{
			padding: .7rem ;
    }
  }
}

.custom-container {
	@include container-padding-private;
	.custom-container {
		transition: all 0.3s ease;
	}

	@include desktop {
		min-height: 60dvh;
	}

	@include desktop-xl {
		min-height: 70dvh;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/BackBtnLayout.vue